export default "__VITE_ASSET__D320PTXb__"